<template>
  <pre
    class="body-2 whitespace-pre-wrap break-all"
    v-html="description"
  />
</template>

<script>
export default {
  name: 'CCarDescription',
  props: {
    description: {
      type: String,
      default: ''
    }
  }
}
</script>
